import { useRef } from "react";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import SweetAlertService from "../../../services/SweetAlertService";
import { DeleteWorkActivityPopupConfirmationMessage } from "../../admin/Shared/Constants/AdminModuleConstants";
import WorkActivityService from "../Services/WorkActivityService";
import { activityMaxLength, categoryMaxLength } from "../Shared/Constants/AppConstant";
import './workActivity.css';

export const WorkActivity = () => {
    const [memberWorkActivities, setMemberWorkActivities] = useState<any>();
    //Category activities pop up
    const [jobCategoryWorkActivities, setJobCategoryWorkActivities] = useState([]);
    const [selectedCategoryWorkActivities, setSelectedCategoryWorkActivities] = useState<any>([]);
    const userDefinedCategory = useRef<any>(null);
    const [showJobCategory, setShowJobCategory] = useState(false);

    //SubCategory activities pop up
    const [jobSubCategoryWorkActivities, setJobSubCategoryWorkActivities] = useState([]);
    const [selectedSubCategoryWorkActivities, setSelectedSubCategoryWorkActivities] = useState<any>([]);
    const userDefinedSubCategory = useRef<any>(null);
    const [showJobSubCategory, setShowJobSubCategory] = useState(false);

    const [selectedCategoryId, setSelectedCategoryId] = useState();
    const [isUserDefinedCategoryAdded, setIsUserDefinedCategoryAdded] = useState(true);

    useEffect(() => {
        getMemberWorkActivities();
    }, []);

    //To get member work activities
    const getMemberWorkActivities = () => {
        WorkActivityService.getAllMemberActivities().then((response: any) => {
            setMemberWorkActivities(response.data);
        }).catch(() => {
            SweetAlertService.error("Error", `Error while getting member work activities`);
        })
    }

    //To capture selected categories in category activity popup
    const handleCategoryWorkActivitiesChange = (event: any) => {
        const value = Number(event.target.value);
        const isChecked = event.target.checked;
        if (isChecked) {
            setSelectedCategoryWorkActivities([...selectedCategoryWorkActivities, value]);
        } else {
            setSelectedCategoryWorkActivities(selectedCategoryWorkActivities.filter((item: any) => item !== value));
        }
    };

    //To call on saving category activity modal popup
    const handleCategoryWorkActivityCloseModal = () => {
        if (isValidName(userDefinedCategory?.current?.value, categoryMaxLength, showCategoryTextBox)) {
            let payload = { JobCategoryIds: selectedCategoryWorkActivities, UserDefinedJobCategory: userDefinedCategory?.current?.value.trim() }
            WorkActivityService.saveCategoryWorkActivities(payload).then((res: any) => {
                if (res.data) {
                    setShowJobCategory(false);
                    SweetAlertService.success("Success", "Category saved successfully");
                    getMemberWorkActivities();
                }
                else {
                    setShowJobCategory(false);
                }
            }).catch((error) => {
                SweetAlertService.error('Error', error.response.data.errors[""]);
            })
        }
    }

    const [errors, setErrors] = useState({ name: "" });
    //To check for valid state
    const isValidName = (name: any, maxLength: any, textBoxShown: boolean) => {
        if (!textBoxShown) {
            return true;
        }
        const errors: any = {};
        if (name == "" || name.trim() === '') {
            errors.name = 'Please complete this field';
            setErrors(errors);
            return false;
        }

        if (name.length > maxLength) {
            errors.name = `Name should not exceed ${maxLength} characters`;
            setErrors(errors);
            return false;
        }

        const nameRegex = /^[A-Za-z0-9 ]+$/;
        if (!nameRegex.test(name)) {
            errors.name = 'Only letters and numbers are allowed';
            setErrors(errors);
            return false;
        }
        return true;
    }

    // On click of additional category click
    const OnAdditionalCategoryClick = () => {
        setSelectedCategoryWorkActivities([]);
        setShowCategoryTextBox(false);
        setErrors({ name: "" });
        WorkActivityService.getWorkActivityCategories().then((response) => {
            if (response.data) {
                setJobCategoryWorkActivities(response.data);
                var ids = response.data.filter((x: any) => x.isCategoryChecked == true).map(({ jobCategoryId }: any) => jobCategoryId);
                var isUserDefinedAdded = response.data.filter((x: any) => x.isSystemDefined == false);
                setIsUserDefinedCategoryAdded(isUserDefinedAdded.length >= 1);
                setSelectedCategoryWorkActivities(ids);
                setShowJobCategory(true);
            }
        });
    }

    // To capture selected subcategories in sub category activity popup
    const handleSubCategoryWorkActivitiesChange = (event: any) => {
        const value = Number(event.target.value);
        const isChecked = event.target.checked;
        if (isChecked) {
            setSelectedSubCategoryWorkActivities([...selectedSubCategoryWorkActivities, value]);
        } else {
            setSelectedSubCategoryWorkActivities(selectedSubCategoryWorkActivities.filter((item: any) => item !== value));
        }
    };

    // On click of additional sub category click
    const OnAdditionalSubCategoryClick = (categoryId: any) => {
        setSelectedSubCategoryWorkActivities([]);
        setSelectedCategoryId(categoryId);
        setShowSubCategoryTextBox(false);
        setErrors({ name: "" });
        WorkActivityService.getWorkActivitySubCategories(categoryId).then((response) => {
            if (response) {
                setJobSubCategoryWorkActivities(response.data);
                setShowJobSubCategory(true);
            }
        });
    }

    //To call on saving category activity modal popup
    const handleSubCategoryWorkActivityCloseModal = () => {
        if (isValidName(userDefinedSubCategory?.current?.value, activityMaxLength, showSubCategoryTextBox)) {
            let payload = { WorkActivitySubcategoriesIds: selectedSubCategoryWorkActivities, UserDefinedJobSubCategory: userDefinedSubCategory?.current?.value, JobCategoryId: selectedCategoryId }
            WorkActivityService.saveSubCategoryWorkActivities(payload).then((res: any) => {
                if (res.data) {
                    SweetAlertService.success("Success", "Work activity saved successfully");
                    setShowJobSubCategory(false);
                    getMemberWorkActivities();
                }
                else {
                    setShowJobSubCategory(false);
                }
            }).catch((error) => {
                SweetAlertService.error('Error', error.response.data.errors[""]);
            })
        }
    }

    //To show and hide user defined category text box
    const [showCategoryTextBox, setShowCategoryTextBox] = useState(false);
    const handleToggleCategoryInput = () => {
        setShowCategoryTextBox(!showCategoryTextBox);
    };

    //To show and hide user defined subcategory text box
    const [showSubCategoryTextBox, setShowSubCategoryTextBox] = useState(false);
    const handleToggleSubCategoryInput = () => {
        setShowSubCategoryTextBox(!showSubCategoryTextBox);
    };

    //To remove work activity
    const removeWorkActivity = (workActivityId: any) => {
        SweetAlertService.confirm('Delete', DeleteWorkActivityPopupConfirmationMessage).then((result) => {
            if (result.isConfirmed) {
                WorkActivityService.removeWorkActivitySubCategories(workActivityId).then((res: any) => {
                    if (res) {
                        SweetAlertService.success("Success", "Work activity removed successfully");
                        getMemberWorkActivities();
                    }
                }).catch((error) => {
                    SweetAlertService.error('Error', error.response.data.errors.Id[0]);
                })
            }
        });
    }

    //To remove user-defined activity category
    const removeUserDefinedWorkActivityCategory = (workActivityCategoryId: any) => {
        SweetAlertService.confirm('Delete', DeleteWorkActivityPopupConfirmationMessage).then((result) => {
            if (result.isConfirmed) {
                WorkActivityService.removeUserDefinedWorkActivityCategory(workActivityCategoryId).then((res: any) => {
                    if (res) {
                        SweetAlertService.success("Success", "Work activity category removed successfully");
                        getMemberWorkActivities();
                    }
                }).catch((error) => {
                    SweetAlertService.error('Error', error.response.data.errors.Id[0]);
                })
            }
        });
    }

    //On closing category activity modal pop up
    const handleCloseJobCategoryModal = () => {
        setShowJobCategory(false);
        setShowCategoryTextBox(false);
    }

    //On closing subcategory modal pop up
    const handleCloseJobSubCategoryModal = () => {
        setShowJobSubCategory(false);
        setShowSubCategoryTextBox(false);
    }

    //To clear errors on textbox change
    const onActivityTextboxChange = (event: any, maxLength: any) => {
        const errors: any = {};
        let name = event.target.value;
        if (name == "" || name.trim() === '') {
            errors.name = 'Please complete this field';
            setErrors(errors);
            return false;
        }

        if (name.length > maxLength) {
            errors.name = `Name should not exceed ${maxLength} characters`;
            setErrors(errors);
            return false;
        }

        const nameRegex = /^[A-Za-z0-9 ]+$/;
        if (!nameRegex.test(name)) {
            errors.name = 'Only letters and numbers are allowed';
            setErrors(errors);
            return false;
        }
        setErrors(errors);
    }

    return (
        <>
            <div className="hero-banner hero-banner--background hero-banner--subpage">
                <div className="container">
                    &nbsp;
                    <div className="col-sm-12">
                        <h1 className="mb-2">
                            Work Activities
                        </h1>
                        <p className="fs-6 mb-3">Define the activities you would like to track in your diary. The list below is a starting point.
                            You can <Link to="/workActivity" className="customLink" onClick={OnAdditionalCategoryClick}><u> add/remove categories of work</u></Link> (e.g. Direct clinical
                            care) and add/remove activities listed within each category. You will need to have at least one activity in each category of work to track it in your diary.
                        </p>
                        <p className="fs-6 text-muted mb-1">
                            <strong className= "text-dark">NB:</strong> Duty/on-call periods, breaks and leave will be listed as options when filling in your diary.
                        </p>
                    </div>
                    &nbsp;
                    <div className="col-sm-12">
                        {memberWorkActivities?.workActivityCategories?.map((workActivityCategory: any, index: any) => (
                            <div key={index}>
                                <div className="panel-default">
                                    <div className="panel-heading custom-panel-heading border">
                                        <p><b>{workActivityCategory.name}</b>
                                            {
                                                !workActivityCategory.isSystemDefined && (
                                                    <Link to="/workActivity" type="button" className="pull-right text-secondary" onClick={() => removeUserDefinedWorkActivityCategory(workActivityCategory.jobCategoryId)}>Remove</Link>)
                                            }
                                        </p>)
                                    </div>
                                    <ul className="list-group">
                                        {workActivityCategory.workActivityJobSubCategories.length > 0 ? (
                                            workActivityCategory.workActivityJobSubCategories.map(
                                                (workActivitySubCategory: any, index: any) => (
                                                    <li key={index} className="list-group-item py-2">
                                                        {workActivitySubCategory.name}
                                                        {/*{subCategory.isDefault && <span className="pull-right text-secondary"><i className="bi bi-lock-fill"></i></span>}*/}
                                                        <Link to="/workActivity" type="button" className="pull-right text-secondary" onClick={() => removeWorkActivity(workActivitySubCategory.id)}>Remove</Link>
                                                    </li>
                                                )
                                            )
                                        ) : (<><li className="list-group-item py-2">
                                            <br />
                                            <span className="text-secondary"> You currently have no activities under this category.<br /><br />
                                                Please <Link to="/workActivity" type="button" className="pull-left" onClick={() => OnAdditionalSubCategoryClick(workActivityCategory.jobCategoryId)}><u>add an activity</u></Link> so you can track this category of work in your diary.</span> <br /><br />
                                        </li></>
                                        )}
                                        {workActivityCategory.workActivityJobSubCategories.length > 0 && (
                                            <li className="list-group-item py-2">
                                                <Link
                                                    to="/workActivity"
                                                    type="button"
                                                    className="pull-left"
                                                    onClick={() => OnAdditionalSubCategoryClick(workActivityCategory.jobCategoryId)}
                                                >
                                                    + Add activity for {workActivityCategory.name}
                                                </Link>
                                            </li>
                                        )}
                                    </ul>
                                </div>
                                <br /> <br />
                            </div>
                        ))}
                        <div className="col-md-3 px-0">
                            <Link to="/workActivity" className="customLinkCategories" onClick={OnAdditionalCategoryClick}>
                                <img src={require("../../../../src/assets/images/showhidecategories.png")} className="pb-1"
                                />  <b>Show/hide additional categories</b>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={showJobCategory} backdrop="static" onHide={handleCloseJobCategoryModal} size="lg">
                <Modal.Header className="modal-header-no-border" closeButton>
                    <Modal.Title>Work categories</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Show or hide the overall categories of work you would like to track in your diary.</p>
                    {jobCategoryWorkActivities.map((jobCategory: any) => (
                        <div key={jobCategory.jobCategoryId}>
                            <p><input
                                type="checkbox"
                                id={jobCategory.id}
                                value={jobCategory.jobCategoryId}
                                checked={selectedCategoryWorkActivities.includes(jobCategory.jobCategoryId)}
                                onChange={handleCategoryWorkActivitiesChange} /> {jobCategory.name}
                            </p>
                        </div>
                    ))}
                    {!isUserDefinedCategoryAdded && (<><Link to="/workActivity" type="button" className="customLink" onClick={handleToggleCategoryInput} >Other (add your own)</Link><br /></>)}
                    {showCategoryTextBox && (<>
                        <span className="mb-2">Category name</span><br />
                        <input type="text" onChange={(e) => onActivityTextboxChange(e, categoryMaxLength)} ref={userDefinedCategory} className="form-control col-md-12" placeholder="Please enter a category name" />
                        {errors.name && <span className="help-block m-b-none text-danger field-validation-valid">{errors.name.toString()}</span>}
                    </>)}
                </Modal.Body>
                <Modal.Footer className="modal-footer-no-border d-flex justify-content-start">
                    <button className="btn btn-primary" onClick={handleCategoryWorkActivityCloseModal}>Save</button>
                </Modal.Footer>
            </Modal>

            <Modal show={showJobSubCategory} backdrop="static" onHide={handleCloseJobSubCategoryModal} size="lg">
                <Modal.Header className="modal-header-no-border" closeButton>
                    <Modal.Title>Add activities</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {jobSubCategoryWorkActivities.map((workActivitySubCategory: any) => (
                        <div key={workActivitySubCategory.jobSubCategoryId}>
                            <p><input
                                type="checkbox"
                                id={workActivitySubCategory.jobSubCategoryId}
                                value={workActivitySubCategory.jobSubCategoryId}
                                onChange={handleSubCategoryWorkActivitiesChange} /> {workActivitySubCategory.name}
                            </p>
                        </div>
                    ))}
                    <Link to="/workActivity" type="button" className="customLink" onClick={handleToggleSubCategoryInput}>Other (add your own)</Link><br />
                    {showSubCategoryTextBox && (<><span className="mb-2">Activity name</span><br /><br />
                        <input type="text" onChange={(e) => onActivityTextboxChange(e, activityMaxLength)} ref={userDefinedSubCategory} className="form-control col-md-12" placeholder="Please enter an activity name." />
                        {errors.name && <span className="help-block m-b-none text-danger field-validation-valid">{errors.name.toString()}</span>}
                    </>)}
                </Modal.Body>
                <Modal.Footer className="modal-footer-no-border d-flex justify-content-start">
                    <button className="btn btn-primary" onClick={handleSubCategoryWorkActivityCloseModal}>Save</button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
